// import { createSelector } from 'reselect';
import { getPaging, mountSelectorAt } from 'utils/selectors';
import { createSelector } from 'reselect';
import { isComment } from 'commentsResourceTypes';
import * as commentsSelectors from 'selectors/comments';
import * as forumSelectors from 'selectors/forum';
import * as magazineSelectors from 'selectors/magazine';

const mount = mountSelectorAt('search');

export const getSearchBar = mount(localState => localState.bar);

export const getSearchPaging = mount((localState, key, options) => getPaging(localState.paging[key], options));

export const getSearchTabs = mount(localState => localState.tabs);

export const getSearchTotalCounts = mount((localState, key, term) => {
  const magazineQueryString = JSON.stringify({ term, category: 'magazine' });
  const forumQueryString = JSON.stringify({ term, category: 'forum' });

  return {
    magazineTotalCount: getPaging(localState.paging[key], { queryString: magazineQueryString}).totalCount,
    forumTotalCount: getPaging(localState.paging[key], { queryString: forumQueryString}).totalCount
  };
});

export const getSearchResultsIds = mount((localState, props) => {
  const { queryString, page } = props;
  const pagesForQuery = localState.results.byQuery[queryString];

  if(!pagesForQuery) {
    return [];
  }

  const searchResultsIds = pagesForQuery.byPage[page];

  if(!searchResultsIds) {
    return [];
  }

  return searchResultsIds;
});

export const getSearchBarState = state => state.search;

export const getSearchResults = createSelector(
  [getSearchResultsIds, magazineSelectors.getMagazineArticlesById, commentsSelectors.getCommentsById, forumSelectors.getForumThreadsById],
  (searchItemsNormalized, magazineArticlesById, commentsById, forumThreadsById) => {
    return searchItemsNormalized.map(searchItemNormalized => {
      const [resourceType, resourceId] = searchItemNormalized.split('-');
      const finalResourceId = parseInt(resourceId, 10);

      // The API search results with a resourceType which maps to the actual type
      if (resourceType === 'article') return ({ article: magazineArticlesById[finalResourceId] });
      if (resourceType === 'forumThread') return ({ forumThread: forumThreadsById[finalResourceId] });
      if (isComment(resourceType)) return ({ comment: commentsById[finalResourceId] });
      return {};
    });
  }
);



/** WEBPACK FOOTER **
 ** ./src/members/state/search/selectors.js
 **/